import { useEffect, useState } from "react";

const contactEndpoint =
  "https://script.google.com/macros/s/AKfycbxI2IEnfzRPETolKIFbbTMo7s-_sAriR1t4M8I_BfM47rUgH_1z/exec";

const countryCodes = [
  { value: "91", label: "+91" },
  { value: "44", label: "+44" },
  { value: "1", label: "+1" },
  { value: "971", label: "+971" },
  { value: "65", label: "+65" },
];

const namePattern = /^[A-Za-z\s.'-]+$/;

const initialState = {
  firstName: "",
  lastName: "",
  email: "",
  mobileCode: "91",
  mobile: "",
  city: "",
  message: "",
};

const socialLinks = [
  { href: "https://www.facebook.com/ipdindia/", label: "Facebook", icon: "/assets/img/facebook.svg" },
  {
    href: "https://www.linkedin.com/in/institute-of-planners-and-designers-india-0414b91b0",
    label: "LinkedIn",
    icon: "/assets/img/linked.svg",
  },
  { href: "https://www.instagram.com/ipdindia/?hl=en", label: "Instagram", icon: "/assets/img/insta.svg" },
  { href: "https://wa.me/918484924004", label: "WhatsApp", icon: "/assets/img/whatsapp.png" },
];

export default function ContactUsPage() {
  const [form, setForm] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("idle"); // idle | submitting | success | error

  useEffect(() => {
    document.title = "Contact Us - IPDI";
  }, []);

  const handleChange = (field) => (e) => {
    let value = e.target.value;
    if (field === "mobile") value = value.replace(/\D/g, "").slice(0, 10);
    setForm((prev) => ({ ...prev, [field]: value }));
    if (["firstName", "lastName"].includes(field) && value.trim() && !namePattern.test(value)) {
      setErrors((prev) => ({ ...prev, [field]: "Name can contain letters only" }));
    } else if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: undefined }));
    }
  };

  const validate = () => {
    const next = {};
    if (!form.firstName.trim()) next.firstName = "Required";
    else if (!namePattern.test(form.firstName.trim())) next.firstName = "Name can contain letters only";
    if (!form.lastName.trim()) next.lastName = "Required";
    else if (!namePattern.test(form.lastName.trim())) next.lastName = "Name can contain letters only";
    if (!form.email.trim()) next.email = "Required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) next.email = "Enter a valid email";
    if (!form.mobile.trim()) next.mobile = "Required";
    else if (!/^\d{10}$/.test(form.mobile)) next.mobile = "Enter a 10-digit number";
    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setStatus("submitting");
    try {
      await fetch(contactEndpoint, {
        method: "POST",
        mode: "no-cors",
        body: new URLSearchParams({
          formName: "Contact Form",
          ...form,
        }),
      });
      setStatus("success");
      setForm(initialState);
    } catch (err) {
      setStatus("error");
    }
  };

  return (
    <div style={styles.page} className="cup-page">
      <style>{RESPONSIVE_CSS}</style>
      <style>{SUCCESS_POPUP_CSS}</style>
      <div style={styles.card} className="cup-card">
        {/* LEFT PANEL */}
        <div style={styles.left} className="cup-left">
          <div>
            <p style={styles.eyebrow}>GET IN TOUCH</p>
            <h1 style={styles.heading} className="cup-heading">
              Contact us
            </h1>
            <p style={styles.subtext}>
              Have a question or need help? Send us a message and our team will get back to you soon.
            </p>

            <p style={styles.includesLabel}>Reach us directly</p>
            <ul style={styles.list}>
              <li style={styles.listItem} className="cup-list-item">
                <span style={styles.check}>✓</span>
                <a href="tel:+919156031516" style={styles.linkPlain}>
                  +91 9156-031-516
                </a>
              </li>
              <li style={styles.listItem} className="cup-list-item">
                <span style={styles.check}>✓</span>
                <a href="mailto:info@ipdi.co.in" style={styles.linkPlain}>
                  info@ipdi.co.in
                </a>
              </li>
            </ul>
          </div>

          <div style={styles.leftFooter}>
            <p style={styles.footerHeading}>Follow us</p>
            <ul style={styles.socialRow} aria-label="Social links">
              {socialLinks.map((social) => (
                <li key={social.label}>
                  <a href={social.href} target="_blank" rel="noreferrer" style={styles.socialLink}>
                    <img src={social.icon} alt={social.label} style={styles.socialIcon} />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div style={styles.right} className="cup-right">
          <form onSubmit={handleSubmit} style={styles.form}>
            <p style={styles.eyebrowDark}>SEND A MESSAGE</p>
            <h2 style={styles.formHeading} className="cup-form-heading">
              Personal Information
            </h2>

            <p style={styles.sectionLabel}>Your details</p>
            <div style={styles.row} className="cup-row">
              <Field
                placeholder="First name *"
                value={form.firstName}
                onChange={handleChange("firstName")}
                error={errors.firstName}
              />
              <Field
                placeholder="Last name *"
                value={form.lastName}
                onChange={handleChange("lastName")}
                error={errors.lastName}
              />
            </div>

            <div style={styles.row} className="cup-row">
              <Field
                type="email"
                placeholder="Email ID *"
                value={form.email}
                onChange={handleChange("email")}
                error={errors.email}
              />
              <div style={styles.fieldWrap}>
                <div style={styles.phoneGroup}>
                  <select
                    value={form.mobileCode}
                    onChange={handleChange("mobileCode")}
                    style={styles.codeSelect}
                  >
                    {countryCodes.map((country) => (
                      <option key={country.value} value={country.value}>
                        {country.label}
                      </option>
                    ))}
                  </select>
                  <input
                    type="tel"
                    inputMode="numeric"
                    placeholder="Mobile no. *"
                    value={form.mobile}
                    onChange={handleChange("mobile")}
                    style={{
                      ...styles.input,
                      ...(errors.mobile ? styles.inputError : {}),
                    }}
                  />
                </div>
                {errors.mobile && <span style={styles.errorText}>{errors.mobile}</span>}
              </div>
            </div>

            <div style={styles.row} className="cup-row">
              <Field
                placeholder="City"
                value={form.city}
                onChange={handleChange("city")}
                error={undefined}
              />
            </div>
            
            <p style={styles.sectionLabel}>Message</p>
            <div style={styles.fieldWrap}>
              <textarea
                placeholder="Enter your message"
                value={form.message}
                onChange={handleChange("message")}
                rows={3}
                style={styles.textarea}
              />
            </div>

            <button type="submit" disabled={status === "submitting"} style={styles.submitBtn}>
              {status === "submitting" ? "SENDING..." : "SEND MESSAGE"}
            </button>


            {status === "error" && <p style={styles.errorMsg}>Unable to send the form right now.</p>}
          </form>
        </div>
      </div>

      {status === "success" ? (
        <div className="cup-success-popup-overlay" onClick={() => setStatus("idle")}>
          <div className="cup-success-popup-card" onClick={(event) => event.stopPropagation()}>
            <div className="cup-success-popup-icon">
              <svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5" /></svg>
            </div>
            <div className="cup-success-popup-title">Application Submitted</div>
            <p className="cup-success-popup-text">
              Thanks for applying to IPDI! Our admissions team will reach out to you shortly on the details you shared.
            </p>
            <button className="cup-success-popup-btn" type="button" onClick={() => setStatus("idle")}>
              Done
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
}

function Field({ type = "text", placeholder, value, onChange, error }) {
  return (
    <div style={styles.fieldWrap}>
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        style={{ ...styles.input, ...(error ? styles.inputError : {}) }}
      />
      {error && <span style={styles.errorText}>{error}</span>}
    </div>
  );
}

const ORANGE = "#c05a3a";
const DARK = "#1c1a17";
const FIELD_BG = "#f0efe9";

const SUCCESS_POPUP_CSS = `
  .cup-success-popup-overlay {
    position: fixed;
    inset: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    background: rgba(28, 26, 23, 0.55);
    animation: cupSuccessFadeIn 0.25s ease;
  }

  .cup-success-popup-card {
    width: 100%;
    max-width: 400px;
    padding: 2.6rem 2rem 2.2rem;
    text-align: center;
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.25);
    animation: cupSuccessPopIn 0.3s ease;
  }

  .cup-success-popup-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 62px;
    height: 62px;
    margin: 0 auto 1.3rem;
    background: #1c1a17;
    border-radius: 50%;
  }

  .cup-success-popup-icon svg {
    width: 28px;
    height: 28px;
    fill: none;
    stroke: #c84b20;
    stroke-width: 2.5;
  }

  .cup-success-popup-title {
    margin-bottom: 0.6rem;
    color: #1c1a17;
    font-family: Georgia, "Times New Roman", serif;
    font-size: 1.4rem;
  }

  .cup-success-popup-text {
    margin-bottom: 1.8rem;
    color: #7d766c;
    font-size: 0.88rem;
    line-height: 1.6;
  }

  .cup-success-popup-btn {
    padding: 0.75rem 2rem;
    color: #fff;
    background: #c84b20;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 0.85rem;
    font-weight: 600;
    transition: background 0.2s ease;
  }

  .cup-success-popup-btn:hover {
    background: #a83e1a;
  }

  @keyframes cupSuccessFadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes cupSuccessPopIn {
    from { opacity: 0; transform: scale(0.92) translateY(10px); }
    to { opacity: 1; transform: scale(1) translateY(0); }
  }
`;
const RESPONSIVE_CSS = `
  @media (min-width: 1600px) {
    .cup-card {
      max-width: 1400px !important;
      margin-left: auto !important;
      margin-right: auto !important;
    }
  }

  @media (max-width: 860px) {
    .cup-page {
      height: auto !important;
      min-height: 100vh;
      align-items: flex-start !important;
      padding: 0 !important;
    }
    .cup-card {
      flex-direction: column !important;
      height: auto !important;
      max-width: 100% !important;
      border-radius: 0 !important;
      box-shadow: none !important;
    }
    .cup-left {
      flex: none !important;
      width: 100%;
      padding: 32px 24px !important;
      box-sizing: border-box;
    }
    .cup-right {
      flex: none !important;
      width: 100%;
      padding: 28px 24px 36px !important;
      justify-content: flex-start !important;
      box-sizing: border-box;
      overflow: visible !important;
    }
    .cup-heading {
      font-size: 32px !important;
    }
    .cup-form-heading {
      font-size: 24px !important;
    }
    .cup-list-item {
      font-size: 14px !important;
    }
    .cup-row {
      flex-direction: column !important;
      gap: 10px !important;
    }
  }

  @media (max-width: 480px) {
    .cup-left {
      padding: 26px 20px !important;
    }
    .cup-right {
      padding: 24px 20px 32px !important;
    }
    .cup-heading {
      font-size: 28px !important;
    }
  }
`;

const styles = {
  page: {
    width: "100%",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#cfc6b3",
    boxSizing: "border-box",
    padding: "1.5vh 2vw",
    fontFamily: "'Helvetica Neue', Arial, sans-serif",
  },
  card: {
    width: "100%",
    maxWidth: "1360px",
    height: "min(94vh, 660px)",
    display: "flex",
    background: "#fff",
    borderRadius: "4px",
    overflow: "hidden",
    boxShadow: "0 10px 40px rgba(0,0,0,0.15)",
  },
  left: {
    flex: "0 0 40%",
    background: DARK,
    color: "#fff",
    padding: "2.6% 2.8%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    boxSizing: "border-box",
  },
  eyebrow: {
    color: ORANGE,
    fontSize: "11px",
    letterSpacing: "2px",
    fontWeight: 700,
    margin: "0 0 10px",
  },
  heading: {
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontSize: "clamp(26px, 2.6vw, 38px)",
    lineHeight: 1.15,
    margin: "0 0 12px",
    fontWeight: 400,
  },
  subtext: {
    fontSize: "13.5px",
    lineHeight: 1.55,
    color: "#c9c6bd",
    margin: "0 0 20px",
    maxWidth: "34ch",
  },
  includesLabel: {
    color: ORANGE,
    fontWeight: 700,
    fontSize: "14px",
    margin: "0 0 10px",
  },
  list: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    display: "flex",
    flexDirection: "column",
    gap: "9px",
  },
  listItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    fontSize: "13px",
    color: "#e9e7e1",
    lineHeight: 1.4,
  },
  linkPlain: {
    color: "inherit",
    textDecoration: "none",
  },
  check: {
    color: ORANGE,
    fontWeight: 700,
    fontSize: "19px",
    lineHeight: 1,
    flexShrink: 0,
  },
  leftFooter: {
    borderTop: "1px solid #3a372f",
    paddingTop: "16px",
    marginTop: "16px",
  },
  footerHeading: {
    fontFamily: "Georgia, serif",
    fontSize: "18px",
    margin: "0 0 12px",
    color: "#f2f0ea",
  },
  socialRow: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    display: "flex",
    gap: "14px",
  },
  socialLink: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  },
  socialIcon: {
    width: "20px",
    height: "20px",
    filter: "brightness(0) invert(1)",
    opacity: 0.9,
  },
  right: {
    flex: "0 0 60%",
    background: "#fff",
    padding: "2.4% 3.2%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    boxSizing: "border-box",
    overflow: "hidden",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  eyebrowDark: {
    color: ORANGE,
    fontSize: "11px",
    letterSpacing: "2px",
    fontWeight: 700,
    margin: "0 0 4px",
  },
  formHeading: {
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontSize: "clamp(22px, 2.2vw, 30px)",
    fontWeight: 400,
    color: "#1a1a1a",
    margin: "0 0 14px",
  },
  sectionLabel: {
    fontSize: "11px",
    letterSpacing: "1.2px",
    fontWeight: 700,
    color: "#6b6a63",
    margin: "6px 0 6px",
  },
  row: {
    display: "flex",
    gap: "14px",
    marginBottom: "2px",
  },
  fieldWrap: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
  },
  input: {
    width: "100%",
    height: "46px",
    background: FIELD_BG,
    border: "1px solid transparent",
    borderRadius: "2px",
    padding: "0 14px",
    fontSize: "14px",
    color: "#1a1a1a",
    boxSizing: "border-box",
    outline: "none",
    appearance: "none",
  },
  inputError: {
    border: "1px solid #c0533a",
  },
  phoneGroup: {
    display: "flex",
    gap: "8px",
  },
  codeSelect: {
    flex: "0 0 76px",
    height: "46px",
    background: `${FIELD_BG} url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path d='M0 0 L5 6 L10 0 Z' fill='%234a4941'/></svg>") no-repeat right 10px center`,
    border: "1px solid transparent",
    borderRadius: "2px",
    fontSize: "13px",
    color: "#4a4941",
    padding: "0 22px 0 10px",
    boxSizing: "border-box",
    outline: "none",
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    cursor: "pointer",
    textAlign: "center",
    textAlignLast: "center",
  },
  textarea: {
    width: "100%",
    background: FIELD_BG,
    border: "1px solid transparent",
    borderRadius: "2px",
    padding: "10px 14px",
    fontSize: "14px",
    color: "#1a1a1a",
    boxSizing: "border-box",
    outline: "none",
    resize: "none",
    fontFamily: "inherit",
  },
  errorText: {
    color: "#c0533a",
    fontSize: "11px",
    marginTop: "3px",
  },
  submitBtn: {
    marginTop: "10px",
    height: "48px",
    background: DARK,
    color: "#fff",
    border: "none",
    borderRadius: "2px",
    fontSize: "13px",
    letterSpacing: "1.5px",
    fontWeight: 700,
    cursor: "pointer",
  },
  errorMsg: {
    color: "#c0533a",
    fontSize: "13px",
    marginTop: "6px",
  },
};

